import React, { useState, useRef, useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useGlobalContext } from '../../../Context/GlobalContext';
import Cookies from 'js-cookie';

const AdvancePaidHistoryModel = ({ toggleOffCanvasAction, item, staff, setIsOffCanvasOpenAction, isOffCanvasOpenAction, setPaidPayment }) => {
  const { baseUrl, openToast } = useGlobalContext();
  const [amount, setAmount] = useState(item?.amount ?? "");
  const [note, setNote] = useState(item?.note ?? "");
  const [date, setDate] = useState(item?.date ?? "");
  const [isLoading,setIsLoading]=useState(false)

  async function savePayment() {
    try {
      setIsLoading(true)
      const response = await fetch(baseUrl + "payment/" + item?.id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
        body: JSON.stringify({
          amount: Number(amount),
          note: note,
          date: date,
        })
      })
      if (response.status === 200) {
        const data = await response.json();
        openToast("Payment Updated Successfully", "success");

        // Update the PaymentHistory array
        const updatedStaff = { ...staff }; // Create a shallow copy to maintain immutability
        const salaryDetails = updatedStaff.staffDetails.SalaryDetails[0];
        salaryDetails.PaymentHistory = salaryDetails.PaymentHistory.filter((i) => i.id !== item.id);
        salaryDetails.PaymentHistory.push(data);

        setPaidPayment(updatedStaff); // Update state with the modified object
        setIsOffCanvasOpenAction(); // Close the off-canvas
      } else {
        openToast("An Error Occurred", "error");
      }

    }
    catch (error) {
      openToast("An Error Occured", "error")
    }
    finally{
      setIsLoading(false)
    }
  }

  async function deletePayment() {
    try {
      const response = await fetch(baseUrl + "payment/" + item?.id, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      })
      if (response.status === 200) {
        openToast("Payment Deleted Successfully", "success");
        const updatedStaff = { ...staff };
        const salaryDetails = updatedStaff.staffDetails.SalaryDetails[0];
        salaryDetails.PaymentHistory = salaryDetails.PaymentHistory.filter((i) => i.id !== item.id);
        setPaidPayment(updatedStaff);
        setIsOffCanvasOpenAction();
      } else {
        openToast("An Error Occurred", "error");
      }
    } catch (error) {
      openToast("An Error Occured", "error")
    }
  }
    useEffect(() => {
      if (item) {
            setAmount(item?.amount);
            setNote(item?.note);
            setDate(new Date(item?.date).toISOString().split("T")[0]);
        }
    }, [item])

  return (
    <div
      className={`fixed top-[56px]  right-0 h-screen sm:w-[400px] w-full  z-[9999999] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${isOffCanvasOpenAction ? "translate-x-0" : "translate-x-full"
        }`}
    >
      <div className="relative w-full h-full">
        <div className="flex justify-between items-center border-gray-200 p-4 border-b">
          <h2 className="font-semibold text-[#000] text-[18px]">{staff?.name}</h2>
          <button
            className="text-[black]"
            onClick={setIsOffCanvasOpenAction}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="relative z-[1] bg-red mb-[10px] p-[10px] pb-[20px] w-full max-w-md h-[82%] overflow-y-scroll">

          <div className="flex justify-between items-center bg-[#e1feed] mb-[10px] p-[10px] w-full">
            <p className="flex items-center gap-[10px] font-normal text-muted-foreground text-sm"><CheckCircleOutlineIcon /> {item?.type}ADVANCE PAID</p>
          </div>
          <div className='flex justify-between items-center gap-[10px] pt-[14px]'>
            <label className='font-light text-[14px]'>Amount</label>
            <div className='relative'>
              <input value={amount} type="number" onChange={(e) => setAmount(e.target.value)} className='focus:shadow-cs px-[10px] py-[5px] pl-[20px] border rounded-[10px] w-[232px] focus-visible:outline-none' />
              <span className='top-[6px] left-[10px] absolute'>₹</span>
            </div>
          </div>
          <div className='flex justify-between items-center gap-[10px] pt-[14px]'>
            <label className='font-light text-[14px]'>Notes</label>
            <div className=''>
              <textarea value={note} onChange={(e) => setNote(e.target.value)} className='focus:shadow-cs px-[10px] py-[5px] pl-[20px] border rounded-[10px] w-[232px] font-light focus-visible:outline-none' />
            </div>
          </div>

          <div className="flex justify-between items-center bg-[#e5e7eb3b] mt-[14px] mb-[10px] p-[10px] w-full">
            <p className="font-normal text-muted-foreground text-sm">Payment Mode</p>
            <p className={`font-normal text-muted-foreground text-sm`} >Save Payment</p>
          </div>

          <div className='flex justify-between items-center gap-[10px] pt-[14px]'>
            <label className='font-light text-[14px] whitespace-nowrap'>Payment Date</label>
            <div className=''>
              <input type="date" defaultValue={(date)} onChange={(e) => setDate(e.target.value)} className='focus:shadow-cs px-[10px] py-[5px] pl-[20px] border rounded-[10px] w-[232px] font-light focus-visible:outline-none' />
            </div>
          </div>

          <div className='bottom-[40px] sm:bottom-[20px] left-0 absolute w-full'>
            <div className='flex justify-between px-[20px]'>
              <button onClick={deletePayment} className={`border-1 hover:bg-red-600 px-[20px] border border-red-600 rounded-[10px] w-[48%] font-normal text-[15px] text-red-600 hover:text-white transition-all  `}>Delete</button>
              <button className={`justify-center w-[48%] second-btn ${isLoading && isLoading==true? "opacity-50 cursor-not-allowed" :"opacity-100" }`} onClick={savePayment}>Save Payment</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdvancePaidHistoryModel